



































import {
  Component,
  Prop,
  Model,
  Watch,
  Mixins,
} from 'vue-property-decorator';
// import {v}
import { FitHalfScreenDialog, FitButton, FitIcon } from '@tencent/wphk-ui';
import FormMixin from '../../../common/mixins/formMixin';
import ScrollList from '../../picker/src/scrollList.vue';
import {
  transformStringToTime,
  formatDate,
} from '../../date-picker/date';

interface DateItem {
  label: string;
  value: number;
}

interface DefaultDateData {
  defaultYear: number;
  defaultMonth: number;
  defaultDate: number;
  startYear: number;
  startMonth: number;
  startDate: number;
  endYear: number;
  endMonth: number;
  endDate: number;
}

const cacheMap: any = {};

const getTotalDateByYearAndMonth = (year: number, month: number) => {
  const d = +new Date(year, month, 1);
  const preDate = new Date(d - 1000);
  return preDate.getDate();
};
const create = (
  start: number,
  end: number,
  suffix: string,
  type: string,
  labelTransform: Function,
) => {
  const cacheKey = `${start}_${end}_${suffix}`;
  if (cacheMap[cacheKey]) {
    return cacheMap[cacheKey];
  }
  const list: DateItem[] = [];
  for (let i = start; i <= end; i++) {
    list.push({
      label: labelTransform(i, type, suffix),
      value: i,
    });
  }
  cacheMap[cacheKey] = list;
  return list;
};

@Component({
  components: {
    FitHalfScreenDialog,
    FitButton,
    ScrollList,
    FitIcon,
  },
})
export default class FitDatePicker extends Mixins(FormMixin) {
  @Model('change') public value!: any;
  @Prop() public title!: string;
  @Prop() public placeholder!: string;
  // @Prop()public visible!: boolean;
  @Prop({ default: true }) public maskClose!: boolean;
  @Prop() public confirmBtnText!: string;
  @Prop() public items!: DateItem[];
  @Prop({ default: () => new Date('1990/01/01') }) public start!: Date | string;
  @Prop({ default: () => new Date('2018/12/01') }) public defaultValue!: Date;
  @Prop({ default: () => new Date() }) public end!: Date | string;
  @Prop({ default: () => ['年', '月', '日'] }) public suffix!: string[];
  @Prop({ default: 'DD-MM-YYYY' }) public format!: string;
  @Prop({ default: 'DD-MM-YYYY' }) public outputformat!: string; // 用于label展示
  @Prop({ default: 'DD-MM-YYYY' }) public previewformat!: string; // 用于label展示
  @Prop({ default: false }) public disabled!: boolean;
  @Prop({ default: () => (data, type, suffix) => data + suffix })
  public labelTransform!: Function; // 用于label展示
  public visible = false;
  public items0 = [];
  public items1 = [];
  public curLabel = '';
  public items2 = [];
  public temp0 = 0;
  public temp1 = 0;
  public temp2 = 0;
  public defaultDate: any = '';
  public curYear = 0;
  public curMonth = 0;
  public curDate = 0;
  public dateList: any[] = [];

  @Watch('value')
  public update(value: string) {
    this.setCurDate();
    this.renderList();
    this.confirm();
    this.notify('change', value);
  }
  onClickPicker() {
    if (!this.disabled) {
      this.visible = true;
    }
  }

  public getYear() {
    const { startYear, endYear } = this.defaultDate;
    if (startYear > endYear) {
      return [];
    }
    return create(
      startYear,
      endYear,
      this.suffix[0] as string,
      'year',
      this.labelTransform,
    );
  }

  public getMonthByYear(year: number) {
    const { startYear, endYear, startMonth, endMonth } = this.defaultDate;

    const start = year === startYear ? startMonth : 1;
    const end = year === endYear ? endMonth : 12;

    return create(
      start,
      end,
      this.suffix[1] as string,
      'month',
      this.labelTransform,
    );
  }

  public getDateByMonth(year: number, month: number) {
    const totalDate = getTotalDateByYearAndMonth(year, month);

    const currYearMonth = `${year}_${month}`;
    const { startYear, endYear, startMonth, endMonth, startDate, endDate } = this.defaultDate;
    const startYearMonth = `${startYear}_${startMonth}`;
    const endYearMonth = `${endYear}_${endMonth}`;

    const start = currYearMonth === startYearMonth ? startDate : 1;
    const end = currYearMonth === endYearMonth ? endDate : totalDate;

    return create(
      start,
      end,
      this.suffix[2] as string,
      'date',
      this.labelTransform,
    );
  }

  public setCurDate() {
    this.defaultDate = this.getDefaultDate();
    this.curYear = this.defaultDate.defaultYear;
    this.curMonth = this.defaultDate.defaultMonth;
    this.curDate = this.defaultDate.defaultDate;
  }

  public getDefaultDate(): DefaultDateData {
    const defaultValue =      transformStringToTime(this.value, this.format)
      || transformStringToTime(this.defaultValue, this.format);
    const start = transformStringToTime(this.start, this.format);
    const end = transformStringToTime(this.end, this.format);
    return {
      defaultYear: defaultValue.getFullYear(),
      defaultMonth: defaultValue.getMonth() + 1,
      defaultDate: defaultValue.getDate(),
      startYear: start.getFullYear(),
      startMonth: start.getMonth() + 1,
      startDate: start.getDate(),
      endYear: end.getFullYear(),
      endMonth: end.getMonth() + 1,
      endDate: end.getDate(),
    };
  }

  public renderList() {
    const year = this.curYear;
    const month = this.curMonth;
    const date = this.curDate;
    this.items0 = this.getYear();
    this.temp0 = this.items0.findIndex((item: DateItem) => item.value === year);
    this.items1 = this.getMonthByYear(year);
    const temp1 = this.items1.findIndex((item: DateItem) => item.value === month);
    this.temp1 = temp1 > 0 ? temp1 : 0;
    this.items2 = this.getDateByMonth(year, month);
    const temp2 = this.items2.findIndex((item: DateItem) => item.value === date);
    this.temp2 = temp2 > 0 ? temp2 : 0;
  }

  public confirm() {
    // 长度超过120会报错。。。
    this.$emit('onClose');
    // tslint:disable-next-line:max-line-length
    const value = this.formatOutput(new Date(`${this.curYear}/${this.curMonth}/${this.curDate}`));
    this.curLabel = this.createCurLabel(value);
    this.$emit('change', value, this.curLabel, {
      year: this.curYear,
      month: this.curMonth,
      date: this.curDate,
    });
    this.visible = false;
  }

  public onChange(item: DateItem, index: number, type: number) {
    this.curYear = +type === 0 ? item.value : this.curYear;
    this.curMonth = +type === 1 ? item.value : this.curMonth;
    this.curDate = +type === 2 ? item.value : this.curDate;
    this.renderList();
    this.$emit('onChange', item, index);
  }

  public onClose() {
    this.setCurDate();
    this.$emit('onClose');
    this.visible = false;
  }

  public formatOutput(date: Date) {
    return formatDate(date, this.format);
    // const formatMonth = month.length === 1 ? `0${month}` : month;
    // const formatDate = date.length === 1 ? `0${date}` : date;
    // return this.format.replace('YYYY', year).replace('MM', formatMonth).replace('DD', formatDate);
  }

  public createDateList() {
    const formatStr = this.previewformat;
    const formatArr = formatStr.split('-');
    const dateMap = {
      D: '2',
      M: '1',
      Y: '0',
    };
    return formatArr.map(str => dateMap[str[0]]);
  }

  public createCurLabel(value) {
    if (value) {
      const input = transformStringToTime(value, this.format);
      const output = formatDate(input, this.outputformat || this.format);
      return output;
    }
    return '';
  }

  public created() {
    this.curLabel = this.createCurLabel(this.value);
    this.defaultDate = this.getDefaultDate();
    this.curYear = this.defaultDate.defaultYear;
    this.curMonth = this.defaultDate.defaultMonth;
    this.curDate = this.defaultDate.defaultDate;
    this.dateList = this.createDateList();
    this.renderList();
    // this.confirm();
  }
}
